import { render, staticRenderFns } from "./sellCenterChangeList.vue?vue&type=template&id=9bd77b46&scoped=true&"
import script from "./sellCenterChangeList.vue?vue&type=script&lang=js&"
export * from "./sellCenterChangeList.vue?vue&type=script&lang=js&"
import style0 from "./sellCenterChangeList.vue?vue&type=style&index=0&id=9bd77b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd77b46",
  null
  
)

export default component.exports